export const DEBOUNCE_TIME_500 = 500;
export const DEBOUNCE_TIME = 1500;
export const MAX_SMALL_FILE_SIZE = 2097152;
export const MAX_FILE_SIZE = 10485760;

export const DO_NOT_ASSIGN_VALUE = 'DO_NOT_ASSIGN';

export const FILE_ALLOWED_EXTENSIONS = {
    CSV: '.csv,text/csv,application/vnd.ms-excel',
    IMAGE: 'image/png,image/jpeg,image/jpg',
    PDF: '.pdf,application/pdf',
};

export const DEFAULT_LAT = 4.661833;
export const DEFAULT_LNG = -74.092881;
export const DEFAULT_MAP_PREVIEW_ZOOM = 12;
export const DEBOUNCE_TIME_1000 = 1000;

export const HIIDDEN_FOOTER_ROUTES = ['/panel-layout', '/panel-layout/preview'];

export const PROPOSAL_STATUS = {
    DRAFT: 'draft',
    GENERATED: 'generated',
};

export const TEMPLATE_TYPES = {
    BOM_TYPE: 'bom',
    PDF_TYPE: 'pdf',
    PROPOSAL_TYPE: 'proposal',
    SYSTEM_TYPE: 'system',
};

export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 75, 100];

export const MAX_HEIGHT_IN_MM = 2000;

export const PV_LAYOUT_TYPE = 999;
